(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-detail-navigation"]) return;
  try {
    
  document.body.classList.add('hide-nav-on-scroll-up');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
  if (document.querySelector('.newsletter-section')) {
    if (blogPage.showNewsletterFirstOnly && blogPage.currentPage === 1 || !blogPage.showNewsletterFirstOnly) {
      const newNewsletter = document.querySelector('.newsletter-section');
      newNewsletter.classList.add('main-blog__newsletter','is-col-12', 'is-col-10-lg','grid-col-start-2-lg');
      newNewsletter.querySelector('.contact-block__wrapper').classList.remove('is-col-10-lg','has-col-10-lg','grid-col-start-2-lg');
      newNewsletter.style.gridRow = 2;
      document.querySelector('[data-blog-grid').append(newNewsletter);
    }
    else {
      document.querySelector('.newsletter-section').remove();
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }
  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  document.body.classList.add('hide-nav-on-scroll-up');

  class CollectionNav extends HTMLElement {
    constructor() {
      super();

      this.collectionProducts = document.querySelector('[data-products-wrapper]');
      this.collectionPromoBlocks = document.querySelector('collection-promo-blocks');
      this.singleClasses = ['has-col-1','has-col-2-sm'];
      this.doubleClasses = ['has-col-2', 'collection__grid--alt'];
    
      if (sessionStorage.getItem('collection-view') === 'double') {
        this.toggleDouble();
      }
      else {
        this.toggleSingle();
        sessionStorage.setItem('collection-view', 'single');
      }
    
      this.querySelector('#viewDouble').addEventListener('change', (event) => {
        if (event.target.checked) {
          this.toggleDouble();
          sessionStorage.setItem('collection-view', 'double');
          this.collectionPromoBlocks.loadPromos('mobile-view');
        }
      });
      this.querySelector('#viewSingle').addEventListener('change', (event) => {
        if (event.target.checked) {
          this.toggleSingle();
          sessionStorage.setItem('collection-view', 'single');
          this.collectionPromoBlocks.loadPromos('mobile-view');
        }
      }); 
    }
  
    toggleSingle() {
      this.classList.remove('collection-view--alt');
      this.collectionProducts.classList.remove(...this.doubleClasses);
      this.collectionProducts.classList.add(...this.singleClasses);

      // if product cards have the 'small' class, remove it again
      document.querySelectorAll('[data-product-card]').forEach(productCard => productCard.classList.remove('product-card--small'))
    }

    toggleDouble() {
      this.classList.add('collection-view--alt');
      this.collectionProducts.classList.add(...this.doubleClasses);
      this.collectionProducts.classList.remove(...this.singleClasses);

      // change all 'large' product cards to small ones
      document.querySelectorAll('[data-product-card]').forEach(productCard => !productCard.classList.contains('product-card--large') && productCard.classList.add('product-card--small'))
    }
  }
  customElements.define('collection-nav', CollectionNav);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rich-text-extended"] && !Shopify.designMode) return;
  try {
    
  class RichTextParallax extends HTMLElement {
    constructor() {
      super();
      // "Parallax" effect for banner images
      this.imageToMoveForeground = this.querySelector('[data-image-banner-image-foreground] figure');
      this.imageToMoveBackground = this.querySelector('[data-image-banner-image-background]');
      this.moving = false;

      if (this.imageToMoveForeground && this.imageToMoveBackground) {
        this.imageToMoveForeground.style.transition = 'transform .75s linear';
        this.imageToMoveBackground.style.transition = 'transform .75s linear';

        this.addEventListener("mousemove", this.moveImage, false);
        this.addEventListener("mouseleave", function() {
          // reset
          this.imageToMoveForeground.style.transform = 'translateY(-50%)';
          this.imageToMoveBackground.style.transform = 'translateY(0)';
          this.imageToMoveForeground.style.transition = 'transform .75s linear';
          this.imageToMoveBackground.style.transition = 'transform .75s linear';
          this.moving = false
        });
      }
    }

    moveImage(e) {
      if (!this.moving) {
        this.imageToMoveForeground.style.transition = 'transform .5s linear';
        this.imageToMoveBackground.style.transition = 'transform .5s linear';
      }
      this.moving = !this.moving;
      this.imageToMoveForeground.style.transform = `translateY(-55%)`;
      this.imageToMoveBackground.style.transform = `translateY(10px)`;
    }
  }
  customElements.define('rich-text-parallax', RichTextParallax);

  } catch(e) { console.error(e); }
})();
})();
